import axios from 'axios';

// let base = 'https://www.madridshop.cc/wp-json/wp/v2';
// let base = 'https://f0j48xos.directus.app/items';
// let base = 'http://127.0.0.1:4000';
// let base = 'http://192.53.120.45:4000/';
let base = 'https://hy2022.top';
//let base1 = 'https://mpaytab.top';
let base1 = 'https://mpayerp.top';
//let base1 = 'https://oxaxd.com.cn';
// let url_ = 'https://api.51tracking.com';

// 获取订单列表
export const getOrder = () => {
    return axios.get(`${base}/getorderlist`).then(res => res.data);
}

// 获取商品列表
export const getProduct = cs => {
    return axios.get(`${base}/getproductlist/${cs}`).then(res => res.data);
}

// 操作分页获取 商品列表
export const getProductList = async params => {
    const res = await axios.post(`${base1}/index/erporder/getPL`, params);
    return res.data;
}

// 获取 商品列表 总条数
export const getProductPage = async params => {
    const res = await axios.post(`${base1}/index/erporder/getPLPage`, params);
    return res.data;
}

// 通过 id主键 获取单个订单详情
export const getOD = async id => {
    const res = await axios.get(`${base}/getorderlist/${id}`);
    return res.data;
}

// 通过 site和订单id 获取单个订单详情
export const getOD_ = async params => {
    const res = await axios.get(`${base}/getorderlist`, params);
    return res.data;
}

// 修改单个订单
export const updateOD = id => {
    return axios.get(`${base}/updateorderlist/${id}`).then(res => res.data);
}

//创建国际物流单号
// export const createInt_no = params => {
//     return axios.post(`${url_}/v3/trackings/create`,params).then(res => res.data);
// }

//通过 site和订单id 获取单个订单里的一个或多个商品
export const getProduct_ = params => {
    return axios.post(`${base}/getLP`,params).then(res => res.data);
}

//编辑 商品名称 || 物流备注 || 物流备注 || 物流备注 || 商品状态 
export const Edit = params => {
    return axios.post(`${base}/productlist`,params).then(res => res.data);
}

//导出的订单改变商品状态
export const DC = async params => {
    const res = await axios.post(`${base}/exportProductList`, params);
    return res.data;
}

//发货按钮
export const Send = params => {
    // return axios.post(`http://193.112.209.104:8082/createOrderApi.htm`,params).then(res => res.data);
    // return axios.post(`/api/createOrderApi.htm`,params).then(res => res.data);
    return axios.post(`${base}/createOrderApi`,params).then(res => res.data);
    // return axios.post(`https://webhook.site/21d86a73-d65e-4a16-931b-9f28b7416b73`,params).then(res => {});
}

// 物流批量修改商品状态
export const wlplxgspzt = async params => {
    const res  = await axios.post(`${base}/wlplxgspzt`, params);
    return res.data;
}

// 获取 Loglist 的记录
export const hqjl = async params => {
    const res = await axios.post(`${base}/hqjl`,params);
    return res.data;
}

// //获取Directus(订单列表)中的数据
// export const getOrder = page => {
//     // return axios.get(`${base}/orderlist/?limit=-1`).then(res => res.data);
//     return axios.get(`${base}/orderlist`, {params:{limit: page}}).then(res => res.data);
// };
// //获取Directus(订单详情)中的某一条数据
// export const getOD = id => {
//     return axios.get(`${base}/orderdetail/${id}`).then(res => res.data);
// };
// //获取Directus(订单详情)中的所有数据
// export const getAllOD = () => {
//     return axios.get(`${base}/orderdetail`).then(res => res.data);
// };
// //新增Directus(订单列表)中的数据
// export const newAdd = params => {
//     return axios.post(`${base}/orderlist`, params).then(res => res.data);
// };
// //新增Directus(订单详情)中的数据
// export const newAdd_ = params => {
//     return axios.post(`${base}/orderdetail`, params).then(res => res.data);
// };

// //获取文章列表
// export const getArticleList = params => {
//     return axios.get(`${base}/posts`, params).then();
// };
// //获取单篇文章
// export const getArticle = ids => {
//     return axios.get(`${base}/posts/${ids}`).then(res => res.data);
// };
// //获取文章分类
// export const getCategories= params => {
//     return axios.get(`${base}/categories`, params).then(res => res.data);
// };
// //获取文章作者
// export const getAuthor= ids => {
//     return axios.get(`${base}/users/${ids}`).then(res => res.data);
// };